import { UnifiedIcon } from '@/components/UnifiedIcon';

/**
 * Placeholder when `VITE_GOOGLE_CLIENT_ID` is not configured (same look, non-interactive).
 */
export function GoogleSsoButtonFallback() {
  return (
    <button
      type="button"
      data-testid="agents-login-google"
      disabled
      title="Set VITE_GOOGLE_CLIENT_ID to enable Google sign-in"
      className="ds-button-secondary w-full py-2.5 text-sm opacity-60"
    >
      <UnifiedIcon name="GoogleLogo" weight="bold" className="h-4 w-4" />
      Continue with Google
    </button>
  );
}
